import { render, staticRenderFns } from "./del.vue?vue&type=template&id=5490cd1e"
import script from "./del.vue?vue&type=script&lang=js"
export * from "./del.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\GitWorkplace\\物联网\\tenda_iot_system\\node_modules\\_vue-hot-reload-api@2.3.4@vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5490cd1e')) {
      api.createRecord('5490cd1e', component.options)
    } else {
      api.reload('5490cd1e', component.options)
    }
    module.hot.accept("./del.vue?vue&type=template&id=5490cd1e", function () {
      api.rerender('5490cd1e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common-physical-model/del.vue"
export default component.exports